import { defineComponent, PropType, computed, set } from "@vue/composition-api";

type AppData = {
	url:string
};

export const EditApp = defineComponent({
	props:{
		data:{
			type:Object as PropType<AppData>,
			required:true
		}
	},
	setup(props){
		const url = computed({
			get:() => props.data.url,
			set:(v:string) => set(props.data, "url", v)
		});
		return {
			url
		};
	}
});